/**
 * As of 2018/08/21 the only markets with express are en, id, th, vi
 */
export const LOCALES = ['en', 'id', 'th', 'vi', 'ms'];

export default {};
